import { createClient } from '@/lib/supabase/client';

type UserResponse = Awaited<ReturnType<ReturnType<typeof createClient>['auth']['getUser']>>;

let inFlight: Promise<UserResponse> | null = null;

/**
 * `auth.getUser()` for browser code, sharing one request among callers that ask
 * at the same time, as several do while a page mounts.
 *
 * Only the in-flight request is shared. Nothing is kept once it settles, so a
 * later caller still sees a sign-out or a changed session.
 */
export function getClientUser(): Promise<UserResponse> {
  inFlight ??= createClient().auth.getUser().finally(() => {
    inFlight = null;
  });
  return inFlight;
}
